const getCriteriaData = (conversation_criterias, idCriteria) => {
  return conversation_criterias.find(
    (item) => String(item.criteria) === String(idCriteria)
  );
};

export default getCriteriaData